import {
    EDIT_INSTANCE_FORM_NAME,
    getInstanceUuidFromLocation,
    getUserDetailIdFromLocation,
    getOrganizationIdFromLocation
} from "./shared";

import React from "react";
import {connect} from "react-redux";
import {compose, withHandlers, lifecycle} from "recompose";

import { setActiveForm } from "../../../actions/appActions";

import { Button } from "react-md";

import {
    getPerson,
    getOrganizationUserDetail,
    setOrganizationUserDetail,
    getOrganizationUsers,
    getOrganizationUsersAdmin,
    getOrganizationUsersOwner,
    getOrganizationUsersUser
} from "../../../actions/resourceActions";
import {} from "../../../actions/requestActions";
import {DebugElement} from "../../debug";
import {map, isEmpty, find, forEach} from "lodash";
import Translate from "../../Translation";
import {xml_utilities} from "../../utilities/xml_utilities";
import { setDialog } from "../../../actions/dialogActions";

// borrowed from current ui
import Header from "../../../components/ContainerHeader";
import {
    InfoBox,
    InfoBox_Field,
    InfoBox_TextField,
    TouchPageHeader,
    TouchPageHeader_and_content_spaceBetween
} from "../../../AtollonTheme/ReactElements";
import {InstanceUserDetail_Editor_AsReduxObject} from "./InstanceUserDetail_Editor";


////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

let InstanceUser = function( userXmlAsString )
{
    this.userXml = xml_utilities.xml_from_string_dontThrowExceptions( userXmlAsString );
};

InstanceUser.prototype.userDetail_get_userName = function()
{
    let self = this;
    let userXml = this.userXml;
    return xml_utilities.get_first_tag_value(userXml,'//userName','');
};

InstanceUser.prototype.userDetail_get_contactName = function()
{
    let userXml = this.userXml;
    return xml_utilities.get_first_tag_value(userXml,'//contactName','');
};

// return: array of groupInfoAsStruct
InstanceUser.prototype.userDetail_get_GROUP = function()
{
    let userXml = this.userXml;
    return xml_utilities.get_array_of_structures_by_xpath(userXml,'//GROUP');
};

InstanceUser.prototype.userDetail_get_GROUP_name = function(groupInfoAsStruct)
{
    return groupInfoAsStruct.name;
};

InstanceUser.prototype.userDetail_get_GROUP_id = function(groupInfoAsStruct)
{
    return groupInfoAsStruct.id;
};

InstanceUser.prototype.userDetail_get_ROLE = function()
{
    let userXml = this.userXml;
    return xml_utilities.get_array_of_structures_by_xpath(userXml,'//ROLE');
};

InstanceUser.prototype.userDetail_get_ROLE_name = (roleInfoAsStruct) =>
{
    return roleInfoAsStruct.name;
};

InstanceUser.prototype.userDetail_get_ROLE_id = (roleInfoAsStruct) =>
{
    return roleInfoAsStruct.id;
};

InstanceUser.prototype.userDetail_get_profileName = function()
{
    let userXml = this.userXml;
    let ret = xml_utilities.get_first_tag_value(userXml,'//profileName');
    return ret;
};

InstanceUser.prototype.userDetail_get_active = function()
{
    let userXml = this.userXml;
    let ret = xml_utilities.get_first_tag_value(userXml,'//active');
    return ret;
    // let retAsBoolean = ret === "true"? true : false;
    // return retAsBoolean;
};

InstanceUser.prototype.userDetail_get_canSeeAdminTree = function()
{
    let userXml = this.userXml;
    let ret = xml_utilities.get_first_tag_value(userXml,'//canSeeAdminTree');
    // let retAsBoolean = ret === "true"? true : false;
    return ret;
};

InstanceUser.prototype.userDetail_get_isPublicUser = function()
{
    let userXml = this.userXml;
    let ret = xml_utilities.get_first_tag_value(userXml,'//isPublicUser');
    return ret;
};

InstanceUser.prototype.userDetail_get_isPublicUser_as_boolean = function()
{
    let ret = this.userDetail_get_isPublicUser();
    let retAsBoolean = ret === "true"? true : false;
    return retAsBoolean;
};

InstanceUser.prototype.userDetail_get_forwardingEmail = function()
{
    let userXml = this.userXml;
    let ret = xml_utilities.get_first_tag_value(userXml,'//forwardingEmail');
    return ret;
};

InstanceUser.prototype.getInitialValuesForReduxForm = function()
{
    var initialValues = {};
    initialValues.contactName = this.userDetail_get_contactName();
    initialValues.isPublicUser = this.userDetail_get_isPublicUser();
    initialValues.canSeeAdminTree = this.userDetail_get_canSeeAdminTree();
    initialValues.active = this.userDetail_get_active();
    initialValues.profileName = this.userDetail_get_profileName();
    initialValues.userName = this.userDetail_get_userName();
    initialValues.forwardingEmail = this.userDetail_get_forwardingEmail();
    return initialValues;

};

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const InstanceUserDetailAsReact = ({
                                       // handleSubmit,
                                       history,
                                       person,
                                       userOrganizations,
                                       organizationUserDetails,
                                       location,
                                       title,
                                       organizationUsers,
                                       organizationUsersAdmin,
                                       organizationUsersOwner,
                                       organizationUsersUser,
                                       setDialog,
                                       activeForm,
                                       setActiveForm
                                       // ,
                                       // initialValues
                                   }) => {

    console.log( 'initialValues', activeForm, 1, (activeForm === EDIT_INSTANCE_FORM_NAME ) );

    // shape is stable btw

    let instanceUuid = getInstanceUuidFromLocation(location);
    let userDetailId = getUserDetailIdFromLocation(location);
    let userDetail = null;
    let thisUserTouchEmail = userDetailId;


    const organization = find(userOrganizations, o => o.id === instanceUuid);

    let canRemoveSSO = false;
    {
        // TODO: cleanup? Pasted from organization/TableUers.js
        const usersBoundToInstance = [];

        let updateCanRemoveSSO = ( u ) =>
        {
            let userIdWithEmail = u.name;
            if( userDetailId === u.name )
            {
                canRemoveSSO = true;
            }
        };

        forEach(organizationUsersAdmin, u => {

            updateCanRemoveSSO( u );

            usersBoundToInstance.push({ ...u, role: "admin" });
        });
        forEach(organizationUsersOwner, u => {

            updateCanRemoveSSO( u );

            usersBoundToInstance.push({ ...u, role: "owner" });
        });
        forEach(organizationUsersUser, u => {

            updateCanRemoveSSO( u );

            usersBoundToInstance.push({ ...u, role: "user" });
        });

        var thisUsersBindingToInstance = find(usersBoundToInstance, u => u.name === thisUserTouchEmail);
    }

    if (organization && organizationUserDetails && organizationUserDetails[userDetailId]) {

        let userXmlAsString = organizationUserDetails[userDetailId];

        let instanceUser = new InstanceUser( userXmlAsString );


        /*

                    zda-li je user Power User a/nebo Admin
                    A zda-li je aktivni


                    A name a user name labels jsou prohozene

         */

        let yesNo = (booleanOrTrueFalse) => {
            let boolean;
            if ( booleanOrTrueFalse === "true" )
            {
                boolean = true;
            }
            else if ( booleanOrTrueFalse === "false" )
            {
                boolean = false;
            }
            else
            {
                boolean = booleanOrTrueFalse;
            }

            return boolean? Translate("yes","ano"): Translate("no","ne");
        };

        let title = organization.name;

        if( activeForm === EDIT_INSTANCE_FORM_NAME )
        {
            return(
                <InstanceUserDetail_Editor_AsReduxObject
                    commonTitle={title}
                    initialValues={instanceUser.getInitialValuesForReduxForm()}
                    instanceUser={instanceUser}
                    location={location}
                />
            );
        }
        else
        {
            return (
                <div>

                    <TouchPageHeader title={title} />
                    <TouchPageHeader_and_content_spaceBetween heightPx={50}/>

                    <InfoBox>
                        <DebugElement text={"Atollon/InstaceUserDetail.js"}/>
                        <InfoBox_TextField
                            name={Translate("Uživatelské jméno", "Uživatelské jméno")}
                            value={instanceUser.userDetail_get_userName()}
                        />
                        <InfoBox_TextField
                            name={Translate("Jméno", "Jméno")}
                            value={instanceUser.userDetail_get_contactName()}
                        />
                        <InfoBox_TextField
                            name={Translate("Profil uživatele","Aktivní")}
                            value={yesNo(instanceUser.userDetail_get_active())}
                        />
                        <InfoBox_Field
                            name={Translate("Skupiny", "Skupiny")}
                            value={map(instanceUser.userDetail_get_GROUP(), groupInfo => {
                                    return (
                                        <div>{instanceUser.userDetail_get_GROUP_name(groupInfo)}</div>
                                    );
                                }
                            )}
                        />
                        <InfoBox_Field
                            name={Translate("Role", "Role")}
                            value={map(instanceUser.userDetail_get_ROLE(), roleInfo => {
                                    return (
                                        <div>{instanceUser.userDetail_get_ROLE_name(roleInfo)}</div>
                                    );
                                }
                            )}
                        />
                        <InfoBox_TextField
                            name={Translate("Profil uživatele","Profil uživatele")}
                            value={instanceUser.userDetail_get_profileName()}
                        />
                        <InfoBox_TextField
                            name={Translate("Je admin?","Je admin?")}
                            value={yesNo(instanceUser.userDetail_get_canSeeAdminTree())}
                        />
                        <InfoBox_TextField
                            name={Translate("Typ uživatele","Typ uživatele")}
                            value={!instanceUser.userDetail_get_isPublicUser_as_boolean()? Translate("profil uživatele - Externí uživatel", "Externí uživatel") : Translate("profil uživatele - Power user", "Power user")}
                        />

                        <InfoBox_TextField
                            name={Translate("Typ uživatele","Typ uživatele")}
                            value={instanceUser.userDetail_get_forwardingEmail()}
                        />

                        {
                            canRemoveSSO
                                ?
                            (
                                <Button
                                    raised
                                    className="btn btn-primary"
                                    label={Translate("Remove SSO authorization","Odebrat SSO autorizaci")}
                                    onClick={() => {
                                        setDialog("DeleteOrganizationUserBinding", {
                                            organizationId: organization.id,
                                            userId: thisUsersBindingToInstance.id,
                                            name: thisUsersBindingToInstance.name
                                        })}}
                                >
                                    delete
                                </Button>
                            )
                                :
                                null
                        }

                        <Button
                            raised
                            className="btn btn-primary"
                            label="Edituj uživatele"
                            onClick={() => setActiveForm(EDIT_INSTANCE_FORM_NAME)}
                        >
                        </Button>


                    </InfoBox>
                </div>
            );
        }
    }
    else {
        return (
            <DebugElement text={"InstanceUserDetail -- PASS"}/>
        );
    }
};
/**
 *
 *
 * Redux has this nonsense to wrap around React component.
 * It is intended to pass state from top components
 *
 *
 *
 */

export const InstanceUserDetailAsReduxObject = (compose(
    connect(({
                 app: {
                     form: {
                        activeForm
                     }
                 },
                 resource: {
                     person,
                     organizationUserDetails,
                     organizationUsers,
                     organizationUsersAdmin,
                     organizationUsersOwner,
                     organizationUsersUser
                 }
             }) => ({
        activeForm,
        person,
        organizationUserDetails,
        organizationUsers,
        organizationUsersAdmin,
        organizationUsersOwner,
        organizationUsersUser
    }), {
        getPerson,
        getOrganizationUserDetail,
        getOrganizationUsers,
        getOrganizationUsersAdmin,
        getOrganizationUsersOwner,
        getOrganizationUsersUser,
        setDialog,
        setActiveForm
    }),
    lifecycle({
        async componentWillMount() {
            const {
                getPerson,
                match,
                getRequest,
                getOrganizationUserDetail,
                location,
                getOrganizationUsers,
                getOrganizationUsersAdmin,
                getOrganizationUsersOwner,
                getOrganizationUsersUser,
            } = this.props;

            let organizationId = getOrganizationIdFromLocation(location);
            let userId = getUserDetailIdFromLocation(location);
            await getOrganizationUserDetail(organizationId, userId);
            await getOrganizationUsers(organizationId);
            await getOrganizationUsersAdmin(organizationId);
            await getOrganizationUsersOwner(organizationId);
            await getOrganizationUsersUser(organizationId);
        }
    })
)(InstanceUserDetailAsReact));



// WEBPACK FOOTER //
// ./src/Atollon/pages/InstanceUserDetail/InstanceUserDetail.js